<script setup lang="ts">
import type { LibraryEntry } from '../../lib/library-entries'
import type { ShelfItem } from '../../lib/shelf-items'
import type { CollectionCell } from '../../lib/collection-presentation'
import ComicCard from './comic-card.vue'
import CollectionCard from './collection-card.vue'

/** 書架：作品一格、集合一格。作品的事件原樣往上送，集合的事件另外一組。 */
defineProps<{ items: ShelfItem[] }>()
defineEmits<{
  info: [entry: LibraryEntry]; edit: [entry: LibraryEntry]; read: [entry: LibraryEntry]; backup: [entry: LibraryEntry]; relink: [entry: LibraryEntry]; remove: [entry: LibraryEntry]
  openCollection: [cell: CollectionCell]; readCollection: [cell: CollectionCell]; editCollection: [cell: CollectionCell]; dissolveCollection: [cell: CollectionCell]; deleteCollection: [cell: CollectionCell]
}>()
</script>

<template>
  <div class="comic-grid">
    <template v-for="item in items" :key="item.id">
      <ComicCard v-if="item.kind === 'comic'" :entry="item.entry" @info="$emit('info', $event)" @edit="$emit('edit', $event)" @read="$emit('read', $event)" @backup="$emit('backup', $event)" @relink="$emit('relink', $event)" @remove="$emit('remove', $event)" />
      <CollectionCard v-else :item="item" @open="$emit('openCollection', $event)" @read="$emit('readCollection', $event)" @edit="$emit('editCollection', $event)" @dissolve="$emit('dissolveCollection', $event)" @delete="$emit('deleteCollection', $event)" />
    </template>
  </div>
</template>
